export default {
    '15th': [
        { timeslot: '2:00 pm - 6:00 pm', activity: 'Registration Desk Open', location: 'TBD' },
        //{ timeslot: '12:00 pm - 9:00 pm', activity: 'Information Desk Open', location: 'TBD' },
        { timeslot: '5:30 pm - 6:30 pm', activity: 'Reception', location: 'TBD' },
        { timeslot: '6:45 pm - 8:30 pm', activity: 'Welcome and Plenary Session', location: 'TBD' },

    ],
    '16th': [
        { timeslot: '7:00 am - 9:00 am', activity: 'Coffee', location: 'TBD' },
        { timeslot: '8:00 am - 5:00 pm', activity: 'Registration Desk Open', location: 'TBD' },
        //{ timeslot: '8:00 am - 5:30 pm', activity: 'Information Desk Open', location: 'TBD' },
        { timeslot: '8:30 am - 10:00 am', activity: 'Research and Brief Research Reports Sessions', location: 'TBD' },
        //{ timeslot: '9:20 am - 10:00 am', activity: 'Research Reports Session', location: 'TBD' },
        { timeslot: '10:00 am - 10:30 am', activity: 'Break ', location: 'TBD' },
        { timeslot: '10:30 am - 12:00 pm', activity: 'Working Groups Session', location: 'TBD' },
        { timeslot: '12:00 pm - 1:00 pm', activity: 'Lunch and Graduate Student Mentoring Lunch', location: 'TBD' },
        //{ timeslot: '12:00 pm - 1:00 pm', activity: 'Graduate Student Mentoring Lunch', location: 'TBD' },
        { timeslot: '1:00 pm - 2:30 pm', activity: 'Research and Brief Research Reports Sessions', location: 'TBD' },
        //{ timeslot: '1:50 pm - 2:30 pm', activity: 'Research Reports Session ', location: 'TBD' },
        { timeslot: '2:30 pm - 2:45 pm', activity: 'Break and Poster Setup', location: 'TBD' },
        //{ timeslot: '2:30 pm - 2:45 pm', activity: 'Poster Setup ', location: 'TBD' },
        { timeslot: '2:45 pm - 4:30 pm', activity: 'Business Meeting and Plenary Session', location: 'TBD' },
        { timeslot: '4:30 pm - 5:30 pm', activity: 'Poster Session and Happy Hour', location: 'TBD' },
        { timeslot: '6:00 pm - 7:30 pm', activity: 'Graduate Student Social', location: 'TBD' },
        //{ timeslot: '5:45 pm - 7:45 pm', activity: 'Social Event (optional)', location: 'TBD' },

    ],
    '17th': [
        { timeslot: '7:00 am - 9:00 am', activity: 'Coffee', location: 'TBD' },
        { timeslot: '8:00 am - 5:00 pm', activity: 'Registration Desk Open', location: 'TBD' },
        //{ timeslot: '8:00 am - 5:30 pm', activity: 'Information Desk Open', location: 'TBD' },
        { timeslot: '8:30 am - 10:00 am', activity: 'Research and Brief Research Reports Sessions', location: 'TBD' },
        //{ timeslot: '9:20 am - 10:00 am', activity: 'Research Reports Session', location: 'TBD' },
        { timeslot: '10:00 am - 10:30 am', activity: 'Break', location: 'TBD' },
        { timeslot: '10:30 am - 12:00 pm', activity: 'Working Groups Session', location: 'TBD' },
        { timeslot: '12:00 pm - 1:00 pm', activity: 'Lunch and Graduate Student Mentoring Lunch', location: 'TBD' },
        //{ timeslot: '12:00 pm - 1:00 pm', activity: 'Graduate Student Mentoring Lunch', location: 'TBD' },
        { timeslot: '1:00 pm - 2:30 pm', activity: 'Research and Brief Research Reports Sessions', location: 'TBD' },
        //{ timeslot: '1:50 pm - 2:30 pm', activity: 'Research Reports Session', location: 'TBD' },
        { timeslot: '2:30 pm - 2:45 pm', activity: 'Break and Poster Setup', location: 'TBD' },
        //{ timeslot: '2:30 pm - 2:45 pm', activity: 'Poster Setup', location: 'TBD' },
        { timeslot: '2:45 pm - 4:15 pm', activity: 'Plenary Session', location: 'TBD' },
        { timeslot: '4:30 pm - 5:30 pm', activity: 'Poster Session and Happy Hour', location: 'TBD' },
        { timeslot: '6:30 pm - 7:30 pm', activity: 'Dinner', location: 'TBD' },
        { timeslot: '7:30 pm - 8:30 pm', activity: 'Entertainment: Carolina Shag Dance Lessons', location: 'TBD' },
        { timeslot: '8:30 pm - 10:30 pm', activity: 'DJ and Dancing', location: 'TBD' },

    ],
    '18th': [
        { timeslot: '7:00 am - 9:00 am', activity: 'Coffee', location: 'TBD' },
        //{ timeslot: '8:00 am - 12:00 pm', activity: 'Information Desk Open', location: 'TBD' },
        { timeslot: '8:30 am - 9:10 am', activity: 'Research and Brief Research Reports Session', location: 'TBD' },
        { timeslot: '9:15 am - 10:45 am', activity: 'Plenary Session', location: 'TBD' },
        { timeslot: '10:45 am - 11:00 am', activity: 'Break', location: 'TBD' },
        { timeslot: '10:45 am - 12:30 pm', activity: 'Boxed Lunches Available', location: 'TBD' },
        { timeslot: '11:00 am - 12:30 pm', activity: 'Working Groups Session', location: 'TBD' },
    ],


}


// WEBPACK FOOTER //
// ./src/data/schedule.js